module.exports = __webpack_public_path__ + "img/thumb_30.164bbbeb.jpg";